import React from "react";
import {
  Edit,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
} from "react-admin";

export const DriverMappingEdit = () => (
  <Edit title="Edit Driver Mapping">
    <SimpleForm>

      <ReferenceInput
        source="driverId"
        reference="drivers"
        label="Driver (from Employees)"
        perPage={500}
      >
        <SelectInput optionText="fullName" />
      </ReferenceInput>

      <TextInput
        source="driverName"
        label="Driver Name (snapshot)"
        fullWidth
      />

      <TextInput source="uberId" label="Uber Driver ID" fullWidth />
      <TextInput source="boltId" label="Bolt Driver ID" fullWidth />
      <TextInput source="yangoId" label="Yango Driver ID" fullWidth />
      <TextInput source="zedId" label="Zed Driver ID" fullWidth />

      {/* Name Variations */}
      <ArrayInput source="nameVariations" label="Name Variations">
        <SimpleFormIterator inline>
          <TextInput source="label" label="Variation" />
        </SimpleFormIterator>
      </ArrayInput>

      {/* POS Car Numbers */}
      <ArrayInput source="posCarNumbers" label="POS Car Numbers">
        <SimpleFormIterator inline>
          <TextInput source="plate" label="Car Number" />
        </SimpleFormIterator>
      </ArrayInput>

    </SimpleForm>
  </Edit>
);
